import { gql } from '@apollo/client';

export default gql`
  query ProductFinderContentPageQuery(
    $language: String!
    $category: String
    $previewToken: String
  ) {
    productFinderContentPage(
      category: $category
      language: $language
      previewToken: $previewToken
    ) {
      sections {
        content
        skus
        ctaButtons {
          link
          text
        }
      }
    }
  }
`;
